import React from 'react';
import { modalConfig } from '../../components/applications-modals/modalConfig';
import { useCsrOptionsConditions } from '../../hooks/useCsrOptionsConditions';
import { CsrOptionsProps, withModalWrapper, GIButton } from '../../utils';

const CsrOptions: React.FC<CsrOptionsProps> = ({
    application,
    applicationIndex,
    outBoundButtonStatus,
    myappOveedApplnLockJs,
    myAppEndSEPJs,
}) => {
    const conditions = useCsrOptionsConditions({
        application,
        applicationIndex,
        outBoundButtonStatus,
        myappOveedApplnLockJs,
        myAppEndSEPJs,
    });

    const renderButton = (onClick, messageCode, id) => (
        <GIButton
            id={`csr_option_button_${id}`}
            labelId={messageCode}
            variant="secondary"
            iconPlacement="start"
            onClickHandler={onClick}
            data-automation-id={`csr_option_button_${id}`}
        />
    );

    return (
        <>{conditions.map((item, index) => item.check && <>{renderButton(item.onClick, item.messageCode, index)}</>)}</>
    );
};

export default withModalWrapper(CsrOptions, modalConfig);
